import { hosts as localNewsHosts } from './hasLocalNews';

const hosts = new Set([
  ...localNewsHosts,
  'fashionunited.ie',
  'fashionunited.com.br',
  'fashionunited.jp',
  'fashionunited.dk',
  'fashionunited.com.tr',
  'fashionunited.pl',
]);

const hasNews = (host) => hosts.has(host);

export default hasNews;
